import { type Organization } from "../types.js";

export function OrganizationPicker({
  onChange,
  organizations,
  value,
}: {
  onChange: (id: string) => void;
  organizations: Organization[];
  value?: string;
}) {
  return (
    <label className="mb-6 flex items-center gap-3 text-sm">
      <span className="text-ink/60">Organization</span>
      <select
        value={value || ""}
        onChange={(event) => onChange(event.target.value)}
        className="rounded border border-black/15 px-3 py-1"
      >
        <option value="" disabled>
          Choose an organization
        </option>
        {organizations.map((organization) => (
          <option key={organization.id} value={organization.id}>
            {organization.name}
          </option>
        ))}
      </select>
    </label>
  );
}
